const { PAGE_PROCESS } = require('../constants/interactions');
const { SUPPORTED_LANGUAGES, normalizeLanguage, isSupportedLanguage } = require('../../../translation/const');

const PATH_SEPARATOR = '/';
const PAGE_TYPE_HOMEPAGE = 'homepage';
const RE_LANGUAGE_REGION_SEPARATOR = /[-_]/;

const PAGE_TYPE = {
    HOMEPAGE: PAGE_TYPE_HOMEPAGE,
    SEARCH: 'search',
    RESULTS: 'results',
    HOTEL: 'hotel',
    RESERVATION: 'reservation',
    PAYMENT: 'payment',
    CONFIRMATION: 'confirmation',
    ORDER_CONFIRMATION: 'order-confirmation',
    BOOKINGS: 'bookings',
    AUTH: 'auth',
    LOGIN: 'login',
};

// Page types come from the first route segment in frontend/web utils/App.js and frontend/mobile Containers.jsx.
const PROCESS_BY_PAGE_TYPE = {
    [PAGE_TYPE.HOMEPAGE]: PAGE_PROCESS.SEARCH,
    [PAGE_TYPE.SEARCH]: PAGE_PROCESS.SEARCH,
    [PAGE_TYPE.RESULTS]: PAGE_PROCESS.HOTEL_RESERVATION,
    [PAGE_TYPE.HOTEL]: PAGE_PROCESS.HOTEL_RESERVATION,
    [PAGE_TYPE.RESERVATION]: PAGE_PROCESS.HOTEL_RESERVATION,
    [PAGE_TYPE.PAYMENT]: PAGE_PROCESS.HOTEL_RESERVATION,
    [PAGE_TYPE.CONFIRMATION]: PAGE_PROCESS.HOTEL_RESERVATION,
    [PAGE_TYPE.ORDER_CONFIRMATION]: PAGE_PROCESS.HOTEL_RESERVATION,
    [PAGE_TYPE.BOOKINGS]: PAGE_PROCESS.MY_HOTELS,
    [PAGE_TYPE.AUTH]: PAGE_PROCESS.LOGIN,
    [PAGE_TYPE.LOGIN]: PAGE_PROCESS.LOGIN,
};

const getPageType = (pathname) => {
    if (typeof pathname !== 'string') {
        return;
    }

    const path = pathname.split(/[?#]/)[0];
    const firstSegment = path.split(PATH_SEPARATOR).find((segment) => segment.trim() !== '');

    return firstSegment ? firstSegment.trim().toLowerCase() : PAGE_TYPE_HOMEPAGE;
};

const getPageObject = (pathname) => {
    const page_type = getPageType(pathname);
    if (!page_type) {
        return;
    }

    const page_process = PROCESS_BY_PAGE_TYPE[page_type];

    return {
        page_type,
        ...(page_process && { page_process })
    };
};

const toSupportedLanguage = (language) => {
    const [primaryLanguage] = normalizeLanguage(language).split(RE_LANGUAGE_REGION_SEPARATOR);
    return isSupportedLanguage(primaryLanguage) ? primaryLanguage : undefined;
};

const isHebrewOnly = (user) => !!user?.company?.partners_ui?.force_hebrew_only;

// Profile.language defaults to English, so only an explicit preference may outrank the site locale.
const getPageLanguage = (user, siteLanguage) => {
    if (isHebrewOnly(user)) {
        return SUPPORTED_LANGUAGES.HE;
    }

    return toSupportedLanguage(user?.settings?.language)
        || toSupportedLanguage(siteLanguage)
        || toSupportedLanguage(user?.language);
};

module.exports = {
    PAGE_TYPE,
    getPageType,
    getPageObject,
    getPageLanguage
};
